import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const honeybadger = defineConnector({
  identifier: "honeybadger",
  name: "Honeybadger",
  tagLine: "Error, uptime, and check-in monitoring",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: () => "https://app\\.honeybadger\\.io/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.authToken,
      password: "",
    }),
  steps: [
    {
      title: "Get your authentication token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your [Honeybadger profile page](https://app.honeybadger.io/users/edit) and copy your personal authentication token.",
        },
      ],
    },
    {
      title: "Copy and paste the authentication token into the field below",
      items: [
        {
          kind: "input",
          label: "Personal authentication token",
          required: true,
          target: { kind: "secrets", field: "authToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.honeybadger.io/v2/projects",
  },
});
